/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const resendLoginCodeRequestV4Schema = z.object({
  pendingToken: z
    .string()
    .nullish()
    .describe('The `pendingToken` returned by `auth/login` when `codeRequired` was true.'),
})
